import React from 'react';
import { Button } from '@/components/ui/button';
import { Settings, Plus, Save, Loader2 } from 'lucide-react';

interface EditModeToggleProps {
  isEditMode: boolean;
  onToggle: () => void;
  onShowPalette: () => void;
  isUpdating: boolean;
}

export const EditModeToggle: React.FC<EditModeToggleProps> = ({
  isEditMode,
  onToggle,
  onShowPalette,
  isUpdating,
}) => {
  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      <Button
        onClick={onToggle}
        variant={isEditMode ? "default" : "outline"}
        size="sm"
        className="shadow-lg"
      >
        {isUpdating ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : isEditMode ? (
          <Save className="h-4 w-4" />
        ) : (
          <Settings className="h-4 w-4" />
        )}
        {isEditMode ? 'Save' : 'Edit'}
      </Button>
      
      {isEditMode && (
        <Button
          onClick={onShowPalette}
          variant="outline"
          size="sm"
          className="shadow-lg"
        >
          <Plus className="h-4 w-4" />
          Add Widget
        </Button>
      )}
    </div>
  );
};